// Cosana consent helpers for the Consentmo cookie banner.
//
// 1. While #cart-drawer is open, <html> carries .cosana-cart-drawer-open and the
//    banner is hidden, so the drawer footer ("Zur Kasse", shipping and payment
//    lines) stays visible and tappable before consent. The banner returns when
//    the drawer closes. No consent is written or assumed; Consentmo keeps
//    blocking until the visitor decides.
// 2. Any link whose href ends in #cookie-settings (footer menu item) re-opens
//    the Consentmo preferences dialog so visitors can change or withdraw their
//    consent. Without Consentmo on the page the link navigates normally.
(function () {
  const CLASS = 'cosana-cart-drawer-open';

  // visibility, not display: Consentmo pins "display: block !important" as an
  // inline style on its host (a top-layer popover), which no stylesheet can
  // override. visibility:hidden removes it from hit-testing and restores cleanly.
  const style = document.createElement('style');
  style.textContent = '.' + CLASS + ' csm-cookie-consent { visibility: hidden !important; }';
  document.head.appendChild(style);

  function sync() {
    const drawer = document.getElementById('cart-drawer');
    document.documentElement.classList.toggle(CLASS, !!drawer && drawer.hasAttribute('open'));
  }

  // Prestige's dialog element dispatches a bubbling "toggle" event on every
  // open/close; capture also catches it if a future version stops bubbling.
  document.addEventListener('toggle', function (event) {
    if (event.target && event.target.id === 'cart-drawer') sync();
  }, true);

  sync();

  document.addEventListener('click', function (event) {
    const link = event.target && event.target.closest ? event.target.closest('a[href$="#cookie-settings"]') : null;
    if (!link || !window.Consentmo || typeof window.Consentmo.openDialog !== 'function') return;
    event.preventDefault();
    window.Consentmo.openDialog();
  });
})();
